import { PortalLayout } from '@/components/contractor-portal/PortalLayout';
import { PortalRouteGuard } from '@/components/contractor-portal/PortalRouteGuard';
import { RatingsHistoryList } from '@/components/partners/RatingsHistoryList';
import { useContractorProfile } from '@/hooks/useContractorProfile';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Info } from 'lucide-react';

export default function ContractorPortalRatings() {
  const { profile } = useContractorProfile();

  return (
    <PortalRouteGuard>
      <PortalLayout>
        <div className="space-y-6">
          <div>
            <h1 className="text-3xl font-bold text-foreground">Performance Ratings</h1>
            <p className="text-muted-foreground mt-1">
              View your company's performance history
            </p>
          </div>

          <Alert>
            <Info className="h-4 w-4" />
            <AlertDescription>
              Ratings are provided by project teams to track performance across safety, quality, and reliability metrics.
              These ratings help maintain high standards and identify areas for improvement.
            </AlertDescription>
          </Alert>

          <Card>
            <CardHeader>
              <CardTitle>Rating History</CardTitle>
              <CardDescription>
                Complete performance evaluation history for {profile?.company?.name}
              </CardDescription>
            </CardHeader>
            <CardContent>
              {profile?.company_id ? (
                <RatingsHistoryList companyId={profile.company_id} />
              ) : (
                <div className="text-center py-8 text-muted-foreground">
                  No company information available
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </PortalLayout>
    </PortalRouteGuard>
  );
}
